import { render, staticRenderFns } from "./profilpdf.vue?vue&type=template&id=da632622&"
import script from "./profilpdf.vue?vue&type=script&lang=js&"
export * from "./profilpdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports